import { render } from "./AppConfig.vue?vue&type=template&id=0576323b&scoped=true"
import script from "./AppConfig.vue?vue&type=script&lang=js"
export * from "./AppConfig.vue?vue&type=script&lang=js"

import "./AppConfig.vue?vue&type=style&index=0&id=0576323b&scoped=true&lang=css"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0576323b"]])

export default __exports__